import httpClient from "../utils/httpClient";

export async function getAppConfig() {
  const res = await httpClient.get("/api/config");
  return res?.data ?? res;
}
